<template>
  <div class="step-exponent__wrapper">
    <message-block
      v-if="
        $store.state.flowEditorLocale &&
          step.action === 'message' &&
          step.message.type === 'text'
      "
      ref="stepElement"
      v-model="steps[index]"
      :blockId="blockId"
    ></message-block>

    <redirect-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'redirect'"
      ref="stepElement"
    ></redirect-block>

    <replies-block
      v-if="$store.state.flowEditorLocale && step.action === 'qr'"
      ref="stepElement"
      class="block-steps__replies"
      v-model="steps[index]"
      :blockId="blockId"
      @refreshActionsPos="$emit('refreshActionsPos')"
    ></replies-block>

    <group-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'group'"
      ref="stepElement"
    ></group-block>

    <data-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'data'"
      ref="stepElement"
    ></data-block>

    <attachment-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'attachment'"
      ref="stepElement"
    ></attachment-block>

    <carousel-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'carousel'"
      ref="stepElement"
      @loading="$refs.imageLoader.show()"
      @loadingEnd="$refs.imageLoader.hide()"
    ></carousel-block>

    <code-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'code'"
      ref="stepElement"
    ></code-block>

    <function-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'function'"
      ref="stepElement"
    ></function-block>

    <contact-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'contact'"
      ref="stepElement"
    ></contact-block>

    <regulations-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'regulations'"
      ref="stepElement"
    ></regulations-block>

    <user-delete-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'delete'"
      ref="stepElement"
    ></user-delete-block>

    <user-input-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'input'"
      ref="stepElement"
    ></user-input-block>

    <comment-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'comment'"
      ref="stepElement"
    ></comment-block>

    <email-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'email'"
      ref="stepElement"
    ></email-block>

    <media-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'media'"
      ref="stepElement"
    ></media-block>

    <if-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'if'"
      ref="stepElement"
    ></if-block>

    <otn-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'otn'"
      ref="stepElement"
    ></otn-block>

    <delayed-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'delay'"
      ref="stepElement"
    ></delayed-block>

    <delayed-cancel-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'delayCancel'"
      ref="stepElement"
    ></delayed-cancel-block>

    <data-load-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'dataLoad'"
      ref="stepElement"
    ></data-load-block>

    <switch-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'switch'"
      ref="stepElement"
    ></switch-block>

    <random-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'random'"
      ref="stepElement"
    ></random-block>

    <goto-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'goto'"
      ref="stepElement"
    ></goto-block>

    <goto-label-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'gotoLabel'"
      ref="stepElement"
    ></goto-label-block>

    <block-insert-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'blockInsert'"
      ref="stepElement"
    ></block-insert-block>

    <handover-block
      :blockId="blockId"
      v-model="steps[index]"
      v-if="step.action === 'handover'"
      ref="stepElement"
    ></handover-block>

    <!-- Loadscreen has to be last element to prevent row controls left offset calculation error -->
    <load-screen
      :startingText="$t('view.flow.editor.imageOperations')"
      ref="imageLoader"
    ></load-screen>
  </div>
</template>

<script>
export default {
  props: ["steps", "step", "blockId", "index"]
};
</script>

<style lang="scss">
.step-exponent {
  &__wrapper {
    width: 100%;
  }
}
</style>
